import { Injectable, signal } from '@angular/core';
import type { ExternalViewRouteData } from './external-view-lookup.service';

/**
 * Holds the external link lookup result for the current `/view/:externalId` navigation.
 * Populated in {@link ExternalViewAuthGuard} because Angular runs `canActivate` before `resolve`.
 */
@Injectable({ providedIn: 'root' })
export class ExternalViewContextService {
	readonly data = signal<ExternalViewRouteData | null>(null);

	setResolved(value: ExternalViewRouteData): void {
		this.data.set(value);
	}

	clear(): void {
		this.data.set(null);
	}
}
